import React from 'react';
import { LessonBlock } from '../../../../models/courses';

export type BlockType = LessonBlock['type'];

const iconProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'currentColor',
  'aria-hidden': true,
} as const;

const TextIcon = () => (
  <svg {...iconProps}>
    <path d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h10v2H4v-2z" />
  </svg>
);

const HeadingIcon = () => (
  <svg {...iconProps}>
    <path d="M5 5h2v6h6V5h2v14h-2v-6H7v6H5V5zm12 4h4v2h-1v8h-2v-8h-1V9z" />
  </svg>
);

const ImageIcon = () => (
  <svg {...iconProps}>
    <path d="M21 5H3a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V6a1 1 0 00-1-1zm-1 12H4v-2l3.5-4.5 2.5 3 3.5-4.5L20 15v2zM8 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
  </svg>
);

const VideoIcon = () => (
  <svg {...iconProps}>
    <path d="M4 5h16a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1zm6 3.5v7l6-3.5-6-3.5z" />
  </svg>
);

const AudioIcon = () => (
  <svg {...iconProps}>
    <path d="M12 3l-1 1v11.1A4 4 0 1013 18V8h4V4h-5V3zm-1 15a2 2 0 110-4 2 2 0 010 4z" />
  </svg>
);

const ButtonIcon = () => (
  <svg {...iconProps}>
    <path d="M3 8a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm2 0v8h14V8H5zm2 3h10v2H7v-2z" />
  </svg>
);

interface BlockMeta {
  type: BlockType;
  label: string;
  icon: React.FC;
}

export const BLOCK_META: Record<BlockType, BlockMeta> = {
  paragraph: { type: 'paragraph', label: 'Текст', icon: TextIcon },
  heading: { type: 'heading', label: 'Заголовок', icon: HeadingIcon },
  image: { type: 'image', label: 'Картинка', icon: ImageIcon },
  video: { type: 'video', label: 'Видео', icon: VideoIcon },
  audio: { type: 'audio', label: 'Аудио', icon: AudioIcon },
  button: { type: 'button', label: 'Кнопка', icon: ButtonIcon },
};

/* Order shown in the add-block toolbar (mirrors the lesson content flow). */
export const BLOCK_ORDER: BlockType[] = [
  'paragraph',
  'heading',
  'image',
  'video',
  'audio',
  'button',
];
